/**
 * Set a cookie that expires after specified amount of days
 * From: https://www.w3schools.com/js/js_cookies.asp
 */
export function setCookie(cookie_name, cookie_value, expire_in_days) {
	var date = new Date()

	date.setTime(date.getTime() + (expire_in_days*24*60*60*1000))
	var expires = "expires="+ date.toUTCString()

	document.cookie = cookie_name + "=" + cookie_value + ";" + expires + ";path=/"
}

/**
 * Get a cookie back from cookie storage
 * From: https://www.w3schools.com/js/js_cookies.asp
 */
export function getCookie(cookie_name) {
	var name = cookie_name + "="
	var decodedCookie = decodeURIComponent(document.cookie)
	var ca = decodedCookie.split(';')

	for (var i = 0; i < ca.length; i++) {
		var c = ca[i]

		while (c.charAt(0) == ' ') {
			c = c.substring(1)
		}

		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length)
		}
	}

	return ""
}